import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Paper, Popper } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";

import { fontRobotoCondensed, transientOptions } from "shared/lib/styles";

import ArrowIcon from "./arrow.svg";

export const DisplayContainer = styled.div`
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;

  cursor: pointer;
`;

type DisplayProps = {
  $isChangedOption: boolean;
};

export const Display = styled.span<DisplayProps>`
  color: ${props => (props.$isChangedOption ? "#000000" : "#4585ff")};
  font-weight: bold;
`;

export const StyledMenu = styled(Popper)`
  z-index: 1;
  & .MuiMenuItem-root {
    min-block-size: 24px;
  }
`;

export const StyledPaper = styled(Paper)`
  z-index: 1;

  inline-size: 180px;
  padding-block: 10px 10px;
`;

type StyledMenuItemProps = {
  $isSelected: boolean;
};

export const StyledMenuItem = styled(MenuItem, { ...transientOptions })<StyledMenuItemProps>`
  gap: 8px;

  color: ${props => (props.$isSelected ? "#4585FF" : "#666666")};
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  & span {
    color: #999999;
  }
`;

type StyledArrowIconProps = {
  $isExpand: boolean;
};
export const StyledArrowIcon = styled(ArrowIcon, { ...transientOptions })<StyledArrowIconProps>`
  margin-inline-start: 10px;

  transform: rotate(0deg);
  ${props => {
    if (!props.$isExpand) return;
    return css`
      transform: rotate(180deg);
    `;
  }}
`;
